import CustomizeHomepageService from '../../services/CustomizeHomepageService';
import customizeHomepageUseCase from './customizeHomepageUseCase';

const customizeHomepageFactory = customizeHomepageUseCase({
  CustomizeHomepageService: CustomizeHomepageService(),
});

export default customizeHomepageFactory;
